var React = require('react');

function IconMenu (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"Open site navigation"),React.createElement("path",{"d":"M0 34.5C0 33.1193 1.11929 32 2.5 32H40.5C41.8807 32 43 33.1193 43 34.5C43 35.8807 41.8807 37 40.5 37H2.5C1.11929 37 0 35.8807 0 34.5Z","fill":"#333333","key":1}),React.createElement("path",{"d":"M0 2.5C0 1.11929 1.11929 0 2.5 0H40.5C41.8807 0 43 1.11929 43 2.5C43 3.88071 41.8807 5 40.5 5H2.5C1.11929 5 0 3.88071 0 2.5Z","fill":"#333333","key":2}),React.createElement("path",{"d":"M0 18.5C0 17.1193 1.11929 16 2.5 16H40.5C41.8807 16 43 17.1193 43 18.5C43 19.8807 41.8807 21 40.5 21H2.5C1.11929 21 0 19.8807 0 18.5Z","fill":"#333333","key":3})]);
}

IconMenu.defaultProps = {"width":"18","height":"18","viewBox":"0 0 43 37","fill":"none"};

module.exports = IconMenu;

IconMenu.default = IconMenu;
